import React, { useEffect, useMemo } from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { useCustomName } from "hooks"
import { FACILITY_KEY } from "utils/customNameHelpers"
import { getActiveOrMatchingFacilities } from "reduxSlices/facilitiesSlice"
import InactiveOptionsItemRenderer from "shared/selects/InactiveOptionsItemRenderer"
import { MultiSelect } from "shared/multiSelects"

const LocationIsAnyOfFacilitiesMatchValueInput = ({
  className = "",
  isFullWidth,
  onChange,
  values = [],
}) => {
  const facilities = useSelector(getActiveOrMatchingFacilities(values))

  const { pluralNameInSentence: facilitiesNameInSentence } = useCustomName(FACILITY_KEY)

  const facilityOptions = useMemo(() => (
    facilities.map((facility) => ({
      label: facility.name,
      value: facility.id,
      active: facility.active,
    }))
  ), [facilities])

  useEffect(() => {
    if ((!values || values.length === 0) && facilityOptions.length !== 0) {
      onChange([facilityOptions[0].value])
    }
  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [])

  return (
    <MultiSelect
      backspaceDelete={false}
      className={className}
      isFullWidth={isFullWidth}
      itemRenderer={InactiveOptionsItemRenderer}
      onChange={onChange}
      options={facilityOptions}
      required
      values={values}
      label={`select one or more ${facilitiesNameInSentence}`}
    />
  )
}

LocationIsAnyOfFacilitiesMatchValueInput.propTypes = {
  className: types.string,
  isFullWidth: types.bool.isRequired,
  onChange: types.func.isRequired,
  values: types.arrayOf(types.number),
}

export default LocationIsAnyOfFacilitiesMatchValueInput
